import { languagesLocale, supportedLanguages } from "@/i18n/config"
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function removeLanguagePrefix(url) {
  const parts = url.split("/")
  if (parts.length > 2 && languagesLocale.includes(parts[1])) {
    return "/" + parts.slice(2).join("/")
  }
  return url
}

export function getCurrentLanguage(url){
  let path
  try {
    // 尝试解析完整的 URL
    const parsedUrl = new URL(url)
    path = parsedUrl.pathname
  } catch (error) {
    // 如果解析失败，假设它是一个相对路径
    path = url
  }

  path = path.replace(/^\/|\/$/g, "")
  const firstPart = path.split("/")[0]
  const matchedLanguage = supportedLanguages.find(
    (lang) => lang.locale === firstPart
  )
  return matchedLanguage?.locale || "en"
}


export function getResponsiveImageUrl(url, screenWidth) {
  const breakpoints = {
    small: 750,
    medium: 1024,
    large: 1200
  };

  const urlParts = url.split('/');
  const fileName = urlParts[urlParts.length - 1];
  const [name, extension] = fileName.split('.');

  let prefix;
  if (screenWidth <= breakpoints.small) {
    prefix = 'small_';
  } else if (screenWidth <= breakpoints.medium) {
    prefix = 'medium_';
  } else if (screenWidth > breakpoints.large) {
    prefix = 'large_';
  } else {
    return url;
  }

  const newFileName = `${prefix}${name}.${extension}`;

  return url.replace(fileName, newFileName);
}

export function transformMenus(inputArray) {
  const result = {};

  inputArray.forEach(item => {
    const parent = item.attributes.parent?.data?.attributes;
    if (parent) {
      const key = parent.title;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push({
        id: item.id,
        attributes: {
          order: item.attributes.order,
          title: item.attributes.title,
          url: item.attributes.url,
          target: item.attributes.target,
          createdAt: item.attributes.createdAt,
          updatedAt: item.attributes.updatedAt,
        }
      });
    }
  });

  for (const key in result) {
    result[key].sort((a, b) => a.attributes.order - b.attributes.order);
  }

  return result;
}